<template>
  <div>
    <h1 class="text-2xl mb-6">Google Trends Exploration</h1>
    <filters></filters>
    <trendsTable></trendsTable>
  </div>
</template>
<script>
import trendsTable from "@/components/gtrends/tables/trendsTable.vue";
import filters from "@/components/gtrends/filters/Filters.vue";
export default {
  name: "gTrendsIndex",
  components: { trendsTable, filters },
};
</script>
<style></style>
